import clsx from 'clsx'
import {FC, useEffect, useState} from 'react'
import {Link} from 'react-router-dom'

/* -------------------- MAIN TABS -------------------- */
type Tab = {link: string; icon: string; label: string; tooltip: string}

const tabs: ReadonlyArray<Tab> = [
  {link: 'oms', icon: 'verified_user', label: 'OMS', tooltip: 'Order Management System'},
  {link: 'users', icon: 'group', label: 'Users', tooltip: 'Users'},
  {link: 'catalogs', icon: 'layers', label: 'Catalogs', tooltip: 'Catalogs'},
  {link: 'transaction', icon: 'receipt_long', label: 'Transaction', tooltip: 'User payment details'},
  {link: 'billing', icon: 'credit_card', label: 'Billing', tooltip: 'Billings'},
  {
    link: 'hpms',
    icon: 'dashboard',
    label: 'HPMS',
    tooltip: 'Healthcare Professional Management System',
  },
  {
    link: 'hppms',
    icon: 'badge',
    label: 'HPPMS',
    tooltip: 'Healthcare Partner Professional Management System',
  },
  // { link: 'cms', icon: 'support_agent', label: 'CMS', tooltip: 'Customer Management System' },
  // { link: 'employers', icon: 'work', label: 'Employers', tooltip: 'Employers' },
  {link: 'vpms', icon: 'storefront', label: 'VPMS', tooltip: 'Vendor Partner Management System'},
  {link: 'hnms', icon: 'local_hospital', label: 'HNMS', tooltip: 'Healon Network Management System'},
]

/* -------------------- SUPER USER ONLY TAB -------------------- */
const superUserTab: Tab = {
  link: 'appsetting',
  icon: 'settings',
  label: 'App Settings',
  tooltip: 'App update setting',
}

export const findTab = (link: string) =>
  [...tabs, superUserTab].find((t) => link?.split('/').filter(Boolean)[0] === t.link)

type Props = {
  link: string
  onSelect: (link: string) => void
}

/* -------------------- COMPONENT -------------------- */
const AsideTabs: FC<Props> = ({link, onSelect}) => {
  const [userRoles, setUserRoles] = useState<string[]>([])

  useEffect(() => {
    const authData = JSON.parse(localStorage.getItem('auth') || 'null')
    const roles = authData?.role?.split(',').map((role: string) => role.trim()) || []
    setUserRoles(roles)
  }, [])

  const isSuperUser = userRoles.includes('superuser')
  const isComsAdmin = userRoles.includes('coms_admin')
  const isSellerVp = userRoles.includes('seller_vp')

  let filteredTabs: ReadonlyArray<Tab> = []

  if (isSuperUser || isComsAdmin) {
    filteredTabs = [...tabs]
  } else if (isSellerVp) {
    filteredTabs = tabs.filter(
      (t) => t.link === 'catalogs' || t.link === 'oms' || t.link === 'transaction'
    )
  }

  /* ---- add appsetting ONLY for superuser ---- */
  if (isSuperUser) {
    filteredTabs = [...filteredTabs, superUserTab]
  }

  const activeLink = findTab(link)?.link

  return (
    <nav className='hl-nav' id='kt_aside_nav_tabs'>
      {filteredTabs.map((t) => {
        const active = activeLink === t.link
        return (
          <Link
            key={t.link}
            to={t.link}
            title={t.tooltip}
            className={clsx('hl-nav-item', {active})}
            onClick={() => onSelect(t.link)}
          >
            <span className='material-symbols-rounded hl-nav-icon'>{t.icon}</span>
            <span className='hl-nav-label'>{t.label}</span>
          </Link>
        )
      })}
    </nav>
  )
}

export {AsideTabs}
